import * as actionTypes from "../actions/actionTypes";
import {
    addRecordFail,
    addRecordStart,
    addRecordSuccess,
    clearAddRecordError,
    clearRecords,
    clearUpdateRecordError,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchRecordsStart,
    updateRecordFail,
    updateRecordStart,
    updateRecordSuccess,
    clearUpdateRecordLoading,
    clearAddRecordLoading,
    cancelAddRecord,
    cancelUpdateRecord,
    updateRecord,
    addRecordToBottom,
    removeRecord,
    fetchRecordStart,
    fetchRecordSuccess,
    fetchRecordFail,
    clearRecord,
    updateSingleRecord
} from "../utility";

const initialState = {
    records: [],
    record: null,
    isLoading: false,
    isRecordLoading: false,
    isRecordAddLoading: null,
    isRecordUpdateLoading: null,
    error: null,
    recordError: null,
    addRecordError: null,
    updateRecordError: null,
    searchParams: {},
    pagination: {},
    addRecordId: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_ACCOUNT_REGISTRATIONS_START: return fetchRecordsStart(state);
        case actionTypes.FETCH_ACCOUNT_REGISTRATIONS_SUCCESS: return fetchRecordsSuccess(state, action.payload);
        case actionTypes.FETCH_ACCOUNT_REGISTRATIONS_FAIL: return fetchRecordsFail(state, action.payload);
        case actionTypes.CLEAR_ACCOUNT_REGISTRATIONS: return clearRecords(state);
        case actionTypes.FETCH_ACCOUNT_REGISTRATION_START: return fetchRecordStart(state);
        case actionTypes.FETCH_ACCOUNT_REGISTRATION_SUCCESS: return fetchRecordSuccess(state, action.payload);
        case actionTypes.FETCH_ACCOUNT_REGISTRATION_FAIL: return fetchRecordFail(state, action.payload);
        case actionTypes.CLEAR_ACCOUNT_REGISTRATION: return clearRecord(state);
        case actionTypes.ADD_ACCOUNT_REGISTRATION: return addRecordToBottom(state, action.payload);
        case actionTypes.ADD_ACCOUNT_REGISTRATION_START: return addRecordStart(state);
        case actionTypes.ADD_ACCOUNT_REGISTRATION_SUCCESS: return addRecordSuccess(state);
        case actionTypes.ADD_ACCOUNT_REGISTRATION_FAIL: return addRecordFail(state, action.payload);
        case actionTypes.ADD_ACCOUNT_REGISTRATION_LOADING_CLEAR: return clearAddRecordLoading(state);
        case actionTypes.ADD_ACCOUNT_REGISTRATION_ERROR_CLEAR: return clearAddRecordError(state);
        case actionTypes.ADD_ACCOUNT_REGISTRATION_CANCEL: return cancelAddRecord(state);
        case actionTypes.UPDATE_ACCOUNT_REGISTRATION: return updateRecord(state, action.payload);
        case actionTypes.UPDATE_SINGLE_ACCOUNT_REGISTRATION: return updateSingleRecord(state, action.payload);
        case actionTypes.UPDATE_ACCOUNT_REGISTRATION_START: return updateRecordStart(state);
        case actionTypes.UPDATE_ACCOUNT_REGISTRATION_SUCCESS: return updateRecordSuccess(state);
        case actionTypes.UPDATE_ACCOUNT_REGISTRATION_FAIL: return updateRecordFail(state, action.payload);
        case actionTypes.UPDATE_ACCOUNT_REGISTRATION_LOADING_CLEAR: return clearUpdateRecordLoading(state);
        case actionTypes.UPDATE_ACCOUNT_REGISTRATION_ERROR_CLEAR: return clearUpdateRecordError(state);
        case actionTypes.UPDATE_ACCOUNT_REGISTRATION_CANCEL: return cancelUpdateRecord(state);
        case actionTypes.REMOVE_ACCOUNT_REGISTRATION: return removeRecord(state, action.payload);
        default:
            return state;
    }
};

export default reducer;